<template>
  <a-select show-search
    :getPopupContainer="node => node.parentNode"
    v-if="selecvalue"
    allowClear
    style="width: 100%"
    :placeholder="placeholder"
    :value="selecvalue"
    :disabled="disabled"
    option-filter-prop="children"
    :filter-option="filterOption"
    @change="onChange">
    <a-select-option v-for="(item,index) in dictOptions"
      :key="index"
      :value="item.value">
      {{item.text}}
    </a-select-option>
  </a-select>
  <a-select show-search
    allowClear
    :getPopupContainer="node => node.parentNode"
    v-else
    :disabled="disabled"
    :placeholder="placeholder"
    option-filter-prop="children"
    style="width: 100%"
    :filter-option="filterOption"
    @change="onChange">
    <a-select-option v-for="(item,index) in dictOptions"
      :key="index"
      :value="item.value">
      {{item.text}}
    </a-select-option>

  </a-select>
</template>

<script>
import { ajaxGetDictItems, ajaxcategory } from '@/api/api'
import Vue from 'vue'
export default {
  name: 'HOneSelecTag',
  props: {
    dictCode: String,
    placeholder: String,
    disabled: Boolean,
    value: String || Number,
  },
  data() {
    return {
      dictOptions: [],
      tagType: "",
      selecvalue: ""
    }
  },
  created() {
  },
  watch: {
    dictCode: {
      immediate: true,
      handler() {
        this.initDictData()
      },
    },
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selecvalue = val
        } else {
          this.selecvalue = []
        }
      },
    },
  },
  methods: {
    report() {
      console.log(this)
      ajaxcategory(this.dictCode, null).then((res) => {
        if (res.success) {
          this.dictOptions = res.result
        }
      })
    },
    initDictData() {
      let that = this;
      if (that.options && that.options.length > 0) {
        that.dictOptions = [...that.options]
        // 增加了 && that.dictCode!=="ajaxGetDictItems"  针对 ajaxGetDictItems 做特殊处理
      } else if (Vue.ls.get(that.dictCode)  && that.dictCode!=="clueinfo_progress"  ) {
        that.dictOptions = Vue.ls.get(that.dictCode);
      } else {
        if (that.dictCode) {
          //根据字典Code, 初始化字典数组
          ajaxGetDictItems(that.dictCode, null).then((res) => {
            if (res.success) {
              if(that.dictCode === "clueinfo_progress"){
                //针对  clueinfo_progress  做特殊处理
                let optionData = res.result.filter(item=>{
                  if(item.value == "9" || item.value == "6" || item.value == "7" || item.value == "3" || item.value == "4"){
                    return false;
                  }
                  return true
                });
                that.dictOptions =optionData
                return
              }else{
                that.dictOptions = res.result;
                that.$ls.set(that.dictCode, res.result)
              }
            }
          })
        }


      }

    },
    onChange(selectedValue) {
      this.$emit('change', selectedValue);
      this.$emit('add', selectedValue);
    },
    setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions
    },
    getCurrentDictOptions() {
      return this.dictOptions
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>
